import React, { useState } from 'react';
import Modal from '../ui/Modal';

const BlogCard = ({ post }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Handle Airtable attachments - check for both images and videos
  const getFeaturedMedia = () => {
    if (post.FeaturedImage && post.FeaturedImage.length > 0) {
      return { type: 'image', url: post.FeaturedImage[0].url };
    }
    if (post.featuredImage && post.featuredImage.length > 0) {
      return { type: 'image', url: post.featuredImage[0].url };
    }
    if (post.FeaturedVideo && post.FeaturedVideo.length > 0) {
      return { type: 'video', url: post.FeaturedVideo[0].url };
    }
    if (post.featuredVideo && post.featuredVideo.length > 0) {
      return { type: 'video', url: post.featuredVideo[0].url };
    }
    return null;
  };

  const featuredMedia = getFeaturedMedia();
  const title = post.Title || post.title;
  const excerpt = post.Excerpt || post.excerpt;
  const content = post.Content || post.content || 'No content available.';
  const date = post.CreatedAt || post.Date || post.createdAt;
  const author = post.Author || post.author;

  return (
    <>
      <article className="blog-card">
        {featuredMedia && (
          <div className="blog-card-media-container">
            {featuredMedia.type === 'image' ? (
              <img 
                src={featuredMedia.url} 
                alt={title}
                className="blog-card-media"
              />
            ) : (
              <div className="blog-card-video-container">
                <video 
                  className="blog-card-media"
                  muted
                  playsInline
                  preload="metadata"
                  poster={post.VideoThumbnail?.[0]?.url} // Optional thumbnail
                >
                  <source src={featuredMedia.url} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <div className="video-play-overlay">
                  <div className="play-button">
                    ▶
                  </div>
                </div>
                <div className="video-badge">VIDEO</div>
              </div>
            )}
          </div>
        )}
        <div className="blog-card-content">
          <h3 className="blog-card-title">{title}</h3>
          <p className="blog-card-excerpt">
            {excerpt || 'No excerpt available'}
          </p>
          <div className="blog-card-footer">
            <div className="blog-card-meta">
              {date && (
                <span className="blog-card-date">
                  {new Date(date).toLocaleDateString()}
                </span>
              )}
              {author && (
                <span className="blog-card-author">By {author}</span>
              )}
            </div>
            <button 
              className="blog-card-read-more"
              onClick={() => setIsModalOpen(true)}
            >
              {featuredMedia?.type === 'video' ? 'Watch' : 'Read More'}
            </button>
          </div>
        </div>
      </article>

      {/* Modal for full article/video */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className="article-modal">
          {featuredMedia && (
            <div className="article-modal-media">
              {featuredMedia.type === 'image' ? (
                <img 
                  src={featuredMedia.url} 
                  alt={title}
                />
              ) : (
                <video 
                  controls
                  autoPlay
                  className="modal-video"
                >
                  <source src={featuredMedia.url} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
            </div>
          )}
          <div className="article-modal-content">
            <h1 className="article-modal-title">{title}</h1>
            <div className="article-modal-meta">
              {date && (
                <span className="article-modal-date">
                  {new Date(date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </span>
              )}
              {author && (
                <span className="article-modal-author">By {author}</span>
              )}
              {featuredMedia?.type === 'video' && (
                <span className="article-modal-video-badge">Video Content</span>
              )}
            </div>
            {featuredMedia?.type === 'video' ? (
              <div className="video-description">
                <p>{content}</p>
              </div>
            ) : (
              <div className="article-modal-body">
                {content.split('\n').map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default BlogCard;